import { lazy } from 'react';
import * as Sentry from '@sentry/react';

type ComponentImportType = () => Promise<{ default: React.ComponentType }>;

const HAS_RETRIED_LAZY_LOADING_STORAGE_KEY = 'has_retried_lazy_loading';

const lazyWithRetry = (componentImport: ComponentImportType) => lazy(async () => {
  const hasRetriedLazyLoading = globalThis.sessionStorage.getItem(HAS_RETRIED_LAZY_LOADING_STORAGE_KEY) === 'true' || false;

  try {
    return await componentImport();
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setTags({
        description: 'React lazy-loading error',
      });
      Sentry.captureException(error);
    });
  }

  if (!hasRetriedLazyLoading) {
    globalThis.sessionStorage.setItem(HAS_RETRIED_LAZY_LOADING_STORAGE_KEY, 'true');
    globalThis.location.reload();
    return { default: () => null };
  }

  throw new Error('Lazy loading failed');
});

export default lazyWithRetry;
